module.exports = __webpack_public_path__ + "assets/img/2@3x.e23f6ccb.png";